export default __webpack_public_path__ + "scripts/resources/assignments/en/Stoichiometry/oracle-temp-2-not-hidden/species.json";